define([
  "globals",
  "jquery",
  "knockout",
  "underscore",
  "autocomplete",
  "typeahead.js",],
function(globals, $, ko, _, Autocomplete) {

  "use strict";

  ko.bindingHandlers.koAutocomplete = {

    init: function(element, valueAccessor) {

      var siteId = globals !== undefined ? globals.siteId : window.siteId;
      var isMobile = globals.ssm.states[0].active;
      if (siteId !== 11) {

        var autocomplete = new Autocomplete();
        $.when(autocomplete.getData()).done(function(autoCompleteData) {

          var jsonData = JSON.parse(autoCompleteData);

          var prefix = (globals.siteId === 1) ? "ab" : "bdc";
          $(element).typeahead({
            hint: true,
            highlight: true,
            minLength: 1,
            classNames: {
              wrapper: prefix + "-typeahead-wrapper",
              input: prefix + "-typeahead-input",
              hint: prefix + "-typeahead-hint",
              menu: prefix + "-typeahead-menu",
              dataset: prefix + "-typeahead-dataset",
              suggestion: prefix + "-typeahead-suggestion",
              selectable: prefix + "-typeahead-selectable",
              empty: prefix + "-typeahead-empty",
              open: prefix + "-typeahead-open",
              cursor: prefix + "-typeahead-cursor",
              highlight: prefix + "-typeahead-highlight"
            }
          },
          {
            name: "label",
            displayKey: "label",
            source: autocomplete.substringMatcher(jsonData),
            limit: 6,
            templates: {
                suggestion: function (queryItem) {

                  if ($(".bdc-captive-header-autocomplete").length > 0) {
                      return "<div><a href='#'>" + queryItem.label + "</a></div>";
                  }
                  else {
                    return "<div>" + queryItem.label + "</div>";
                  }
              }
            }
          });

          // Goes to URL when item is selected
          $("input").on("typeahead:selected", function(x) {
              var clickedOptionValue = this.value;

            var objFound = _.find(jsonData, function(obj) {
              return obj.label === clickedOptionValue;
              });
            if ($(".bdc-captive-header-autocomplete").length > 0) {
                search();
            }
            else {
                if (objFound.url.indexOf('?') != -1) {
                    objFound.url += "&searchType=redirect";
                } else {
                    objFound.url += "?searchType=redirect";
                }
                window.location.href = objFound.url;
            }
          });

          // Scroll page to Inline Search when mobile menu is open
          if (isMobile) {
            $("#gcc-inline-search").focus(function() {
              if ($(this).offset().top > 120) {
                $("html, body").animate({
                  scrollTop: $(this).offset().top - 10
                }, 500);
              }
            });
          }
        });
      }
    }
  };

});
